import AppInstance from "@/lib/AppInstance";
import App from './App.vue'
import router from './router'
import store from './store'
import { Auth0 } from "@/auth/Auth0";
import '@/assets/styles/app.scss'
import Default from "@/layouts/Default";
import createAxiosInstance from '@/lib/axios';
import Helpers from '@/lib/helpers'
import { Promised } from 'vue-promised'
import { abilitiesPlugin } from '@casl/vue';
import { defineAbility } from "@casl/ability";
import Can from "@/components/permissions/Can";
import Pusher from "./lib/Pusher"
import Buefy from 'buefy'
// import 'buefy/dist/css/buefy.css'
import ValidationProvider from "@/components/validation/ValidationProvider";
import ValidationObserver from "@/components/validation/ValidationObserver";
import componentBus from '@/lib/ComponentEventBus'
import LdSkeleton from "@/components/skeletons/LdSkeleton";
import FloatingVue from 'floating-vue'
import {createLoggerInstance} from "@/lib/Log";
import HelpScout from "@/lib/HelpScout";
import { initSentry } from '@/initializers/sentry';
import { initHighcharts } from '@/initializers/highcharts';
import { initValidation } from '@/initializers/validation';
import { initLogRocket } from '@/initializers/logrocket';
import { initInputGuard } from '@/initializers/inputGuard';

const app = AppInstance.create(App)
app.use(router)
app.use(store)

const axiosInstance = createAxiosInstance(router)
store.$http = axiosInstance
app['$http'] = axiosInstance
app.config.globalProperties['$http'] = axiosInstance
const loggerInstance = createLoggerInstance(axiosInstance)
app.config.globalProperties['$logger'] = loggerInstance
app.mixin({
  data() {
    return {
      http: axiosInstance
    }
  }
})

for (const [key, value] of Object.entries(componentBus)) {
  app.config.globalProperties[key] = value
}

app.use(Pusher, {
  appKey: import.meta.env.VITE_PUSHER_APP_KEY,
  options: {
    cluster: import.meta.env.VITE_PUSHER_APP_CLUSTER,
    authEndpoint: `${import.meta.env.VITE_API_BASE_URL}/v1/pusher/auth`
  }
});

app.use(abilitiesPlugin, defineAbility(() => {}), {
  useGlobalProperties: true
})

app.use(Buefy, {
  defaultNoticeQueue: false
})

app.use(Auth0, {
  clientId: import.meta.env.VITE_AUTH0_CLIENT_ID,
  domain: import.meta.env.VITE_AUTH0_DOMAIN,
  audience: import.meta.env.VITE_AUTH0_AUDIENCE,
  redirectUri: `${import.meta.env.VITE_BASE_URL}/`,
  router,
  axiosInstance,
  loggerInstance
});

app.use(FloatingVue, {
  themes: {
    'badge-popper': {
      $extend: 'dropdown',
    },
    'lookdeep-global': {
      $extend: 'tooltip',
    },
    'lookdeep-ai': {
      $extend: 'menu',
    },
  },
})

app.use(Helpers, { store })
app.component('Can', Can);
app.component('Promised', Promised)
app.component('default-layout', Default)
app.config.productionTip = false
app.directive('tooltip', FloatingVue.vTooltip)
app.use(HelpScout, { key: import.meta.env.VITE_HELPSCOUT_KEY })
app.component('LdSkeleton', LdSkeleton)
app.component('ValidationProvider', ValidationProvider)
app.component('ValidationObserver', ValidationObserver)

var strategies = app.config.optionMergeStrategies
strategies.widget = strategies.methods


if (['qa', 'ai', 'app'].includes(import.meta.env.VITE_ENVIRONMENT_NAME) && !navigator.userAgent?.includes("HeadlessChrome")) {
  initSentry(app, router);
}

if (['qa', 'ai', 'app'].includes(import.meta.env.VITE_ENVIRONMENT_NAME) && !navigator.userAgent?.includes("HeadlessChrome")) {
  initLogRocket();
}

initHighcharts(app);
initValidation();
initInputGuard();

app.mount('#app')